import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
const defaultValues = {name: "",image:""}

const updateUser = (newConf:any)=>{}
const UserContext = createContext({user:defaultValues,updateUser});


export const UserProvider = ({ children }:any) => {
  const [user, setUser] = useState(defaultValues);
  const updateUser = useCallback((newConfig:any) => {
    setUser((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    user,
    updateUser,
  }), [user, updateUser]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};